
import * as z from "zod";

export const jobFormSchema = z.object({
  title: z.string().min(1, "Job title is required"),
  company: z.string().min(1, "Company name is required"),
  location: z.string().min(1, "Location is required"),
  type: z.enum(["full-time", "part-time", "contract", "remote"]),
  salary: z.string().min(1, "Salary range is required"),
  status: z.enum(["open", "closed", "on-hold"]).default("open"),
  description: z.string().optional(),
  requirements: z.string().optional(),
  document_url: z.string().optional(),
  source_url: z.string().optional(),
});

export type JobFormValues = z.infer<typeof jobFormSchema>;
